export function getCSRFToken (): string {
  const tokenElm = document.querySelector('meta[name="csrf-token"]')
  let token = ''
  if (tokenElm !== null) {
    token = tokenElm.getAttribute('content') ?? ''
  }
  return token
}
